<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="图片上传"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="purchaseReceives"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-upload action="#" list-type="picture-card" :auto-upload="false">
          <i slot="default" class="el-icon-plus"/>
          <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"/>
              </span>
              <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                <i class="el-icon-delete"/>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible1" :modal="false">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name:"PictureEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        dialogVisible1: false,
        contentLoading: false,
        submitLoading: false,
        dialogImageUrl: "",
        disabled: false,
        fileList: [],
        purchaseReceives: {
          pkid: 0,
          photos: [],
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.purchaseReceives.pkid = id;
        this.dialogVisible = true;
        //this.getData();
      },
      getData() {
        this.$http
          .get("basic", `purchaseReceives/${this.purchaseReceives.pkid}`)
          .then(resp => {
            this.purchaseReceives = resp;
            console.log(this.purchaseReceives);
          });
      },
      handleRemove(file) {
        console.log(file);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible1 = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
